import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { SolutionSection } from '../components/SolutionSection';
import { PillarsSection } from '../components/PillarsSection';
import { PackageSection } from '../components/PackageSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { OfferSection } from '../components/OfferSection';
import { LegalAccordion } from '../components/LegalAccordion';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-160">
      <HeroSection data-id="element-161" />
      <PainPointsSection data-id="element-162" />
      <SolutionSection data-id="element-163" />
      <PillarsSection data-id="element-164" />
      <PackageSection data-id="element-165" />
      <SocialProofSection data-id="element-166" />
      <OfferSection data-id="element-167" />

      <footer className="bg-gray-50 py-12 border-t border-gray-200" data-id="element-168">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm" data-id="element-169">
          <p data-id="element-170">
            © {new Date().getFullYear()} Hogar Blindado. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-171">
            Este producto no sustituye el consejo médico profesional.
          </p>

          <LegalAccordion data-id="element-172" />
        </div>
      </footer>
    </div>;
}